export default __webpack_public_path__ + "static/media/download-icon.fd87a4b7.svg";